import classNames from 'classnames/bind';
import styles from './LoadingErrorPanel.module.css';
import {
  SUMMARIZING_PAGE,
  SUMMARIZING_PAGE_ERROR,
  PLEASE_RETRY_LATER,
} from '../../../constants';

type LoadingErrorStateProps = {
  isLoading?: boolean;
  isError?: boolean;
  loadingMessage?: {
    line1: string;
    line2: string;
  };
  errorMessage?: {
    line1: string;
    line2: string;
  };
};

export default function LoadingErrorState({
  isLoading = false,
  isError = false,
  loadingMessage = {
    line1: SUMMARIZING_PAGE,
    line2: PLEASE_RETRY_LATER,
  },
  errorMessage = {
    line1: SUMMARIZING_PAGE_ERROR,
    line2: PLEASE_RETRY_LATER,
  },
}: LoadingErrorStateProps) {
  const cx = classNames.bind(styles);

  if (!isLoading && !isError) {
    return null;
  }

  return (
    <div
      className={cx('loading_indicator', {
        error_state: isError,
      })}
    >
      <div>
        {isError ? (
          <>
            <p>{errorMessage.line1}</p>
            <p>{errorMessage.line2}</p>
          </>
        ) : (
          <>
            <p>{loadingMessage.line1}</p>
            <p>{loadingMessage.line2}</p>
          </>
        )}
      </div>
    </div>
  );
}
